import React, { useEffect, useState } from "react";
import { requestArchiveCode, verifyArchiveCode } from "services/storageService/storageService";
import { ActionButton, CodeInput, ErrorText, Modal, ModalActions, ModalBackdrop, ModalTitle, Subtitle } from "pages/StoragePage/StoragePage.styles";

export default function ArchiveConfirmation({ onConfirm, onCancel }: { onConfirm: () => Promise<void>; onCancel: () => void }) {
  const [code, setCode] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [wait, setWait] = useState(0);
  const [error, setError] = useState("");
  useEffect(() => {
    if (!wait) return;
    const timer = window.setTimeout(() => setWait((value) => Math.max(0, value - 1)), 1000);
    return () => window.clearTimeout(timer);
  }, [wait]);
  const send = async () => {
    setBusy(true); setError("");
    try { const result = await requestArchiveCode(); setSent(true); setCode(""); setWait(result.retry_after); }
    catch (e: any) { setError(e?.response?.data?.detail || "Не удалось отправить код."); setWait(e?.response?.data?.retry_after || 0); }
    finally { setBusy(false); }
  };
  const confirm = async () => {
    setBusy(true); setError("");
    try { await verifyArchiveCode(code); await onConfirm(); }
    catch (e: any) { setError(e?.response?.data?.detail || "Не удалось подтвердить действие."); setWait(e?.response?.data?.retry_after || 0); }
    finally { setBusy(false); }
  };
  return <ModalBackdrop><Modal role="dialog" aria-modal="true" aria-labelledby="archive-confirm-title">
    <ModalTitle id="archive-confirm-title">Отправить курс в архив?</ModalTitle>
    <Subtitle>Это не удаляет курс и не закрывает доступ ученикам. Вернуть курс можно через «Хранилище». Для подтверждения получите код на почту школы.</Subtitle>
    {sent ? <CodeInput aria-label="Код архивации" inputMode="numeric" autoComplete="one-time-code" value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))} /> : null}
    {error ? <ErrorText role="alert">{error}</ErrorText> : null}
    <ModalActions>
      <ActionButton disabled={busy} onClick={onCancel}>Отмена</ActionButton>
      <ActionButton disabled={busy || wait > 0} onClick={() => void send()}>{wait ? `Новый код через ${wait} сек.` : sent ? "Новый код" : "Получить код"}</ActionButton>
      {sent ? <ActionButton $primary disabled={busy || code.length !== 6} onClick={() => void confirm()}>Подтвердить архивацию</ActionButton> : null}
    </ModalActions>
  </Modal></ModalBackdrop>;
}
